import { Button, Filestack } from "@govlaunch/core";
import ProfilePicture from "@govlaunch/profile-picture";
import React from "react";
import { Field } from "react-final-form";
import * as palette from "@govlaunch/palette";
import { FormattedMessage } from "react-intl";

interface IVendorLogoFieldProps {
  vendorName: string;
}

export default function VendorLogoField({ vendorName }: IVendorLogoFieldProps) {
  return (
    <Field name="logo">
      {({ input }) => (
        <Filestack
          onSuccess={({ filesUploaded }: any) => input.onChange(filesUploaded[0].url)}
          customRender={({ onPick }: any) => (
            <div>
              <div
                css={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <ProfilePicture xlarge={true} image={input.value} name={vendorName || "A B"} />
              </div>

              <div
                css={{
                  display: "grid",
                  gridAutoFlow: "column",
                  gridAutoColumns: "max-content",
                  justifyContent: "center",
                  gridColumnGap: 5,
                  marginTop: 16,
                }}
              >
                <Button size="xsmall" color={palette.primary} onClick={onPick}>
                  <FormattedMessage defaultMessage="Upload" id="p4N05H" />
                </Button>

                {input.value && (
                  <Button
                    size="xsmall"
                    color={palette.red}
                    theme="secondary"
                    css={{
                      background: "#fff",
                    }}
                    onClick={() => input.onChange(null)}
                  >
                    <FormattedMessage defaultMessage="Remove" id="G/yZLu" />
                  </Button>
                )}
              </div>
            </div>
          )}
        />
      )}
    </Field>
  );
}
